import { ScrollOptions } from 'vue-scrollto'
// @ts-ignore
import { scroller as vueScrollTo } from 'vue-scrollto/src/scrollTo'

export function useScroll() {
  const scroller = vueScrollTo()

  function scrollToTop(options?: ScrollOptions) {
    scroller(document.body, options)
  }

  function scrollTo(element: any, options?: ScrollOptions): void {
    const scroller = vueScrollTo()
    scroller(element, options)
  }

  return { scrollToTop, scrollTo }
}
